import React, { useState } from 'react';
import './ChatHeader.css';

const ChatHeader = ({ botName, botAvatar, user, onSignOut }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);

  return (
    <div className="chat-header">
      <div className="chat-header-left">
        {botAvatar && <div className="bot-avatar-header">{botAvatar}</div>}
        <div className="bot-info">
          <h1 className="chat-title">{botName}</h1>
          <span className="bot-status">
            <span className="status-dot"></span> Online
          </span>
        </div>
      </div>
      
      <div className="chat-header-right">
        <div className="user-menu-container">
          <button 
            className="user-button"
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            <div className="user-avatar">
              {user?.name?.charAt(0).toUpperCase() || 'U'}
            </div>
            <span className="user-name">{user?.name || 'User'}</span>
            <svg 
              className={`chevron ${showUserMenu ? 'open' : ''}`} 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>
          
          {showUserMenu && (
            <>
              <div 
                className="menu-overlay" 
                onClick={() => setShowUserMenu(false)}
              ></div>
              <div className="user-dropdown">
                <div className="user-dropdown-header">
                  <div className="user-avatar-large">
                    {user?.name?.charAt(0).toUpperCase() || 'U'}
                  </div>
                  <div className="user-details">
                    <div className="user-dropdown-name">{user?.name || 'User'}</div>
                    <div className="user-dropdown-email">{user?.email || ''}</div>
                  </div>
                </div>
                <div className="user-dropdown-divider"></div>
                <button 
                  className="logout-button"
                  onClick={() => {
                    setShowUserMenu(false);
                    onSignOut();
                  }}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    <polyline points="16 17 21 12 16 7"></polyline>
                    <line x1="21" y1="12" x2="9" y2="12"></line>
                  </svg>
                  Sign Out
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;

